"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokensService = void 0;
const ethers_1 = require("ethers");
const contracts_1 = require("../contracts");
const service_1 = require("../service");
class TokensService extends service_1.Service {
    constructor(sdk) {
        super(sdk);
        this.tokens = {};
    }
    async loadTokens(addresses) {
        const tokens = await Promise.all(addresses.map(async (addr) => this.loadToken(addr)));
        return Object.fromEntries(tokens.map((token) => [token.address, token]));
    }
    async loadToken(address) {
        const checksumAddress = ethers_1.ethers.utils.getAddress(address);
        if (!this.tokens[checksumAddress]) {
            const token = contracts_1.Erc20__factory.connect(checksumAddress, this.provider);
            const [name, symbol, decimals] = await Promise.all([
                token.name(),
                token.symbol(),
                token.decimals(),
            ]);
            this.tokens[checksumAddress] = {
                address: checksumAddress,
                name,
                symbol,
                decimals,
            };
        }
        return this.tokens[checksumAddress];
    }
    async loadBalances(addresses) {
        const balanceEntries = await Promise.all(addresses.map(async (addr) => {
            const balance = await this.loadBalance(addr);
            return [addr, balance];
        }));
        return Object.fromEntries(balanceEntries);
    }
    async loadBalance(address) {
        if (!this.address) {
            return ethers_1.BigNumber.from(0);
        }
        try {
            const checksumAddress = ethers_1.ethers.utils.getAddress(address);
            const token = contracts_1.Erc20__factory.connect(checksumAddress, this.provider);
            return token.balanceOf(this.address);
        }
        catch (err) {
            console.error(err);
            return ethers_1.BigNumber.from(0);
        }
    }
}
exports.TokensService = TokensService;
//# sourceMappingURL=tokens.service.js.map